import { useEffect } from "react";
import type { MyPayEnvironment } from "../../generated/core-api";
import { useMyPayEnvironments } from "./useMyPayEnvironments";

export interface UseMyPayEnvironmentSelectOptions {
  value: MyPayEnvironment | null;
  onChange: (environment: MyPayEnvironment | null) => void;
  /** Auto-select when the API returns exactly one environment. Default true. */
  autoSelectSingle?: boolean;
}

/**
 * Loads Datapay environments and applies the auto-select-when-single rule so
 * callers (e.g. `MyPayEnvironmentSelect`) stay render-only.
 */
export function useMyPayEnvironmentSelect({
  value,
  onChange,
  autoSelectSingle = true,
}: UseMyPayEnvironmentSelectOptions) {
  const query = useMyPayEnvironments();

  useEffect(() => {
    if (
      autoSelectSingle &&
      value === null &&
      query.data?.length === 1
    ) {
      onChange(query.data[0].environment);
    }
  }, [autoSelectSingle, query.data, onChange, value]);

  return query;
}
